export default "__VITE_ASSET__HLYWQAkZ__"